(() => {
  const script = document.currentScript;
  const pageType = script?.dataset?.pageType || '';
  const productId = script?.dataset?.productId || '';
  if (pageType !== 'product') return;

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const insertMicroProof = () => {
    if (document.querySelector('.gs-pro-micro-proof')) return;
    const price = document.querySelector('.product-info__block-item[data-block-type="price"]');
    if (!price) return;
    const link = document.createElement('a');
    link.className = 'gs-pro-micro-proof';
    link.href = '#gs-community-proof';
    link.innerHTML = '<span aria-hidden="true">♡</span><span>Echte Stimmen aus unserer Goldstück Community</span><span aria-hidden="true">↓</span>';
    price.insertAdjacentElement('afterend', link);
  };

  const insertSizeHelp = () => {
    if (document.querySelector('.gs-pro-size-help')) return;
    const variant = document.querySelector('.product-info__block-item[data-block-type="variant-picker"]');
    const buy = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
    const anchor = variant || buy;
    if (!anchor) return;
    const box = document.createElement('div');
    box.className = 'gs-pro-size-help';
    box.innerHTML = '<span><strong>Noch unsicher?</strong> Frage uns zu Größe, Passform oder Produktdetails.</span><a href="/pages/contact">Wir helfen dir →</a>';
    anchor.insertAdjacentElement('afterend', box);
  };

  const moveSternifyBenefits = () => {
    const blocks = Array.from(document.querySelectorAll('.product-info__block-item'));
    const benefit = blocks.find((block) => {
      const text = normalize(block.textContent).toLowerCase();
      return (text.includes('schnell auf dem weg') || text.includes('schneller versand')) &&
        (text.includes('flexibel bezahlen') || text.includes('ratenzahlung'));
    });
    const buy = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
    if (!benefit || !buy) return;
    benefit.classList.add('gs-pro-sternify-benefits');
    if (buy.nextElementSibling !== benefit) buy.insertAdjacentElement('afterend', benefit);
  };

  const polishFaq = () => {
    const faq = document.querySelector('.st_faq-section');
    if (!faq) return;
    const title = faq.querySelector('.st_faq-title');
    const desiredTitle = 'Noch Fragen? <span class="st_highlight">Wir helfen dir.</span>';
    if (title && title.innerHTML !== desiredTitle) title.innerHTML = desiredTitle;
    faq.querySelectorAll('.st_faq-social-proof').forEach((node) => node.remove());
    const entries = [
      ['Dein Lieblingsstück ist ausverkauft?', '<p>Wähle beim Artikel deine gewünschte Variante und aktiviere die Benachrichtigung, wenn sie angeboten wird. Sobald dein Goldstück wieder verfügbar ist, erfährst du es direkt.</p>'],
      ['Bestellt – und jetzt doch noch etwas ändern?', '<p>Solange dein Paket noch nicht versendet wurde, versuchen wir gerne, deine Bestellung anzupassen. Melde dich dafür am besten so schnell wie möglich bei uns.</p>'],
      ['Noch unsicher bei Größe, Passform oder Produktdetails?', '<p>Schreib uns einfach über den Kontakt. Unser Goldstück-Team berät dich persönlich und ehrlich, damit du dich vor der Bestellung sicherer entscheiden kannst.</p>'],
      ['Passt doch nicht – wie funktioniert die Rückgabe?', '<p>Rückgabefähige Artikel kannst du innerhalb von 14 Tagen an uns zurücksenden:</p><p><strong>Goldstück Schwabach</strong><br>Rathausgasse 4<br>91126 Schwabach</p><p><strong>Bitte beachten:</strong> Für einzelne Warengruppen und Sale-Artikel gelten die in unseren Rückgabebedingungen genannten Ausnahmen.</p>'],
      ['Wann ist mein Goldstück bei mir?', '<p>Wir bearbeiten deine Bestellung so schnell wie möglich und versenden reguläre Lagerware in der Regel am nächsten Werktag. Meistens ist dein Paket innerhalb von 3–4 Tagen bei dir. Für individuell angefertigte Goldstück Studio Artikel gelten die separat angegebenen längeren Lieferzeiten.</p>']
    ];
    faq.querySelectorAll('.st_faq-item').forEach((item, index) => {
      const entry = entries[index];
      if (!entry) return;
      const question = item.querySelector('.st_faq-question');
      const icon = question?.querySelector('.st_faq-icon');
      if (question) {
        const current = normalize(Array.from(question.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE).map((node) => node.nodeValue).join(' '));
        if (current !== entry[0]) {
          question.childNodes.forEach((node) => { if (node.nodeType === Node.TEXT_NODE) node.nodeValue = ''; });
          question.insertBefore(document.createTextNode(entry[0] + ' '), icon || null);
        }
      }
      const answer = item.querySelector('.st_faq-answer-inner');
      if (answer && answer.innerHTML !== entry[1]) answer.innerHTML = entry[1];
    });
  };

  const hideEmptyMaterial = () => {
    document.querySelectorAll('accordion-disclosure.accordion').forEach((accordion) => {
      const title = normalize(accordion.querySelector('summary')?.textContent).toLowerCase();
      if (title !== 'material') return;
      const content = normalize(accordion.querySelector('.accordion__content')?.textContent);
      if (!content) accordion.remove();
    });
  };

  const enhanceCrossSell = () => {
    const sections = Array.from(document.querySelectorAll('.gs-cross-sell'));
    if (sections.length > 1) {
      const primary = sections.find((node) => node.dataset.gsFallback !== 'related') || sections[0];
      sections.forEach((node) => { if (node !== primary) node.remove(); });
    }
    const section = document.querySelector('.gs-cross-sell');
    if (!section) return;
    const isFallback = section.dataset.gsFallback === 'related';
    const eyebrow = section.querySelector('.gs-cross-sell__eyebrow');
    const title = section.querySelector('.gs-cross-sell__title');
    const copy = section.querySelector('.gs-cross-sell__copy');
    if (eyebrow) eyebrow.textContent = isFallback ? 'Für dich entdeckt' : 'Mach deinen Look komplett';
    if (title) title.textContent = isFallback ? 'Noch mehr für dich' : 'Dazu passt perfekt';
    if (copy) copy.textContent = isFallback ? 'Weitere Goldstücke, die zu deinem aktuellen Style passen könnten.' : 'Passende Ergänzungen, mit denen du dein neues Lieblingsstück direkt weiterdenken kannst.';
    section.querySelectorAll('.gs-cross-sell-card__cta').forEach((cta) => { cta.textContent = 'Style ansehen'; });
  };

  const euro = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(cents || 0) / 100);
  const getImage = (product) => {
    if (typeof product?.featured_image === 'string') return product.featured_image;
    if (product?.featured_image?.url) return product.featured_image.url;
    if (typeof product?.images?.[0] === 'string') return product.images[0];
    return product?.images?.[0]?.url || '';
  };

  const buildRelatedFallback = async () => {
    if (!productId || document.querySelector('.gs-cross-sell')) return;
    try {
      const response = await fetch(`/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=4&intent=related`, { headers: { Accept: 'application/json' } });
      if (!response.ok || document.querySelector('.gs-cross-sell')) return;
      const data = await response.json();
      const products = Array.isArray(data?.products) ? data.products.slice(0, 4) : [];
      if (!products.length || document.querySelector('.gs-cross-sell')) return;

      const section = document.createElement('section');
      section.className = 'gs-cross-sell';
      section.dataset.gsFallback = 'related';
      const inner = document.createElement('div');
      inner.className = 'gs-cross-sell__inner';
      inner.innerHTML = '<div class="gs-cross-sell__header"><div><p class="gs-cross-sell__eyebrow">Für dich entdeckt</p><h2 class="gs-cross-sell__title">Noch mehr für dich</h2></div><p class="gs-cross-sell__copy">Weitere Goldstücke, die zu deinem aktuellen Style passen könnten.</p></div>';
      const grid = document.createElement('div');
      grid.className = 'gs-cross-sell__grid';

      products.forEach((product) => {
        const card = document.createElement('a');
        card.className = 'gs-cross-sell-card';
        card.href = product.url || `/products/${product.handle}`;
        const media = document.createElement('span');
        media.className = 'gs-cross-sell-card__media';
        const image = getImage(product);
        if (image) {
          const img = document.createElement('img');
          img.src = image;
          img.alt = product.title || '';
          img.loading = 'lazy';
          media.appendChild(img);
        }
        const info = document.createElement('span');
        info.className = 'gs-cross-sell-card__info';
        const name = document.createElement('span');
        name.className = 'gs-cross-sell-card__name';
        name.textContent = product.title || '';
        const price = document.createElement('span');
        price.className = 'gs-cross-sell-card__price';
        price.textContent = euro(product.price);
        const cta = document.createElement('span');
        cta.className = 'gs-cross-sell-card__cta';
        cta.textContent = 'Style ansehen';
        info.append(name, price, cta);
        card.append(media, info);
        grid.appendChild(card);
      });
      inner.appendChild(grid);
      section.appendChild(inner);
      const mainProduct = document.querySelector('.shopify-section--main-product');
      if (mainProduct) mainProduct.insertAdjacentElement('afterend', section);
    } catch (_) {}
  };

  const organizeSections = () => {
    const mainProduct = document.querySelector('.shopify-section--main-product');
    const confidence = document.getElementById('gs-product-confidence');
    const proof = document.getElementById('gs-community-proof');
    if (!mainProduct || !confidence || !proof) return;

    if (mainProduct.nextElementSibling !== confidence) mainProduct.insertAdjacentElement('afterend', confidence);
    const crossSell = document.querySelector('.gs-cross-sell');
    if (crossSell && confidence.nextElementSibling !== crossSell) confidence.insertAdjacentElement('afterend', crossSell);
    const proofAnchor = crossSell || confidence;
    if (proofAnchor.nextElementSibling !== proof) proofAnchor.insertAdjacentElement('afterend', proof);
    enhanceCrossSell();
  };

  const refresh = () => {
    insertMicroProof();
    insertSizeHelp();
    moveSternifyBenefits();
    polishFaq();
    hideEmptyMaterial();
    organizeSections();
  };

  const init = () => {
    refresh();
    setTimeout(refresh, 250);
    setTimeout(refresh, 700);
    setTimeout(async () => { await buildRelatedFallback(); refresh(); }, 1400);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('change', (event) => {
    if (event.target.closest('.shopify-section--main-product')) setTimeout(refresh, 180);
  });
  document.addEventListener('shopify:section:load', () => setTimeout(refresh, 100));
})();
